export default __webpack_public_path__ + "media/fonts/GTWalsheim/gt-walsheim-bold-web-17cd99571692acab83580349616ba0e8.ttf";